import { action } from 'typesafe-actions';
import { RelevantWebsitePreference,
		 RelevantWebsiteWithPreference,
		 UserPreferences
		} from '../../api/user';
import { ApplicationSlimInfo } from '../../api/application';
import { DashboardItemsActionType, DashboardItems, LoadingInformation } from './types';

export interface GetUsedApplications {
	type: DashboardItemsActionType.GET_USED_APPLICATIONS;
}

export interface GetRecommendedApplications {
	type: DashboardItemsActionType.GET_RECOMMENDED_APPLICATIONS;
}

export interface GetRelevantWebsites {
	type: DashboardItemsActionType.GET_RELEVANT_WEBSITES;
}

export interface SetDashboardItems {
	type: DashboardItemsActionType.SET_DASHBOARD_ITEMS;
    payload: DashboardItems;
}

export interface SetUsedApplications {
	type: DashboardItemsActionType.SET_USED_APPLICATIONS;
    payload: ApplicationSlimInfo[];
}

export interface SetRecommendedApplications {
	type: DashboardItemsActionType.SET_RECOMMENDED_APPLICATIONS;
    payload: ApplicationSlimInfo[];
}

export interface SetAuthorizedApplications {
	type: DashboardItemsActionType.SET_AUTHORIZED_APPLICATIONS;
    payload: ApplicationSlimInfo[];
}

export interface SetRelevantWebsites {
	type: DashboardItemsActionType.SET_RELEVANT_WEBSITES;
    payload: RelevantWebsiteWithPreference[];
}

export interface SetRelevantWebsitesPreferences {
	type: DashboardItemsActionType.SET_RELEVANT_WEBSITES_PREFERENCES;
    payload: RelevantWebsitePreference[];
}

export interface UpdateUserPreferences {
	type: DashboardItemsActionType.UPDATE_USER_PREFERENCES;
    payload: UserPreferences;
}

export interface SetLoadedFalse {
	type: DashboardItemsActionType.SET_LOADED_FALSE;
}

export interface SetRelevantWebsitesLoaded {
	type: DashboardItemsActionType.SET_RELEVANT_WEBSITES_LOADED;
	payload: LoadingInformation;
}

export interface SetApplicationsLoaded {
	type: DashboardItemsActionType.SET_APPLICATIONS_LOADED;
	payload: LoadingInformation;
}

export const setRelevantWebsitesPreferences = (preferences: RelevantWebsitePreference[]): SetRelevantWebsitesPreferences =>
	action(DashboardItemsActionType.SET_RELEVANT_WEBSITES_PREFERENCES, preferences)

export const setUsedApplications = (usedApplications: ApplicationSlimInfo[]): SetUsedApplications =>
	action(DashboardItemsActionType.SET_USED_APPLICATIONS, usedApplications)

export const setRecommendedApplications = (recommendedApplications: ApplicationSlimInfo[]): SetRecommendedApplications =>
	action(DashboardItemsActionType.SET_RECOMMENDED_APPLICATIONS, recommendedApplications)

export const setAuthorizedApplications = (authorizedApplications: ApplicationSlimInfo[]): SetAuthorizedApplications =>
	action(DashboardItemsActionType.SET_AUTHORIZED_APPLICATIONS, authorizedApplications)

export const setRelevantWebsites = (relevantWebsitesWithPreferences: RelevantWebsiteWithPreference[]): SetRelevantWebsites =>
	action(DashboardItemsActionType.SET_RELEVANT_WEBSITES, relevantWebsitesWithPreferences)

export const getUsedApplications = (): GetUsedApplications =>
	action(DashboardItemsActionType.GET_USED_APPLICATIONS);

export const getRecommendedApplications = (): GetRecommendedApplications =>
	action(DashboardItemsActionType.GET_RECOMMENDED_APPLICATIONS);

export const getRelevantWebsites = (): GetRelevantWebsites =>
	action(DashboardItemsActionType.GET_RELEVANT_WEBSITES);

export const updateUserPreferences = (userPreferences: UserPreferences): UpdateUserPreferences =>
	action(DashboardItemsActionType.UPDATE_USER_PREFERENCES, userPreferences);

export const setLoadedFalse = (): SetLoadedFalse =>
	action(DashboardItemsActionType.SET_LOADED_FALSE);

export const setRelevantWebsitesLoaded = (loadingInformation: LoadingInformation): SetRelevantWebsitesLoaded =>
	action(DashboardItemsActionType.SET_RELEVANT_WEBSITES_LOADED, loadingInformation);

export const setApplicationsLoaded = (loadingInformation: LoadingInformation): SetApplicationsLoaded =>
	action(DashboardItemsActionType.SET_APPLICATIONS_LOADED, loadingInformation);

export type DashboardItemActionType = GetUsedApplications |
            GetRecommendedApplications |
			GetRelevantWebsites |
			SetDashboardItems |
			SetRecommendedApplications |
			SetAuthorizedApplications |
			SetRelevantWebsites |
			SetUsedApplications |
			SetRelevantWebsitesPreferences |
			SetRelevantWebsitesLoaded |
			SetApplicationsLoaded |
			SetLoadedFalse;
